// Parser fuer den /wiki|/memory-Slash-Command.
// Extrahiert aus chat-input.tsx, damit er ohne React-Deps testbar ist (B1.7).

export interface WikiInvocation {
  operation: 'create' | 'ingest' | 'query' | 'lint'
  topic?: string
  args?: string
  premium?: boolean
}

export function parseWikiCommand(rest: string): WikiInvocation | null {
  // /wiki <op> [topic|args]
  const trimmed = rest.trim()
  if (!trimmed) return null
  const firstSpace = trimmed.indexOf(' ')
  const op = (firstSpace === -1 ? trimmed : trimmed.slice(0, firstSpace)).toLowerCase()
  const after = firstSpace === -1 ? '' : trimmed.slice(firstSpace + 1).trim()

  if (op === 'create') {
    if (!after) return null
    return { operation: 'create', topic: after }
  }
  if (op === 'ingest') {
    if (!after) return null
    return { operation: 'ingest', args: after }
  }
  if (op === 'query') {
    if (!after) return null
    return { operation: 'query', args: after }
  }
  if (op === 'lint') {
    return { operation: 'lint', topic: after || undefined }
  }
  return null
}
